<mat-dialog-content class="mat-typography">
  <p style="margin: 10px">
    Please email us at
    <a>support&#64;silq.com.au.</a>
    Please provide as much detailed information as possible so we can assist you.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close style="margin-right: 8px; margin-bottom: 5px">Cancel</button>
</mat-dialog-actions>
